import { Instance, types } from 'mobx-state-tree'

const EMIPlan = types.model('emiPlan', {
  allowZeroCost: types.optional(types.string, ''),
  productDiscount: types.optional(types.string, ''),
  productDiscountPercentage: types.optional(types.string, ''),
  programType: types.optional(types.string, ''),
  scheme: types.optional(types.string, ''),
  subventionCashbackDiscount: types.optional(types.string, ''),
  subventionCashbackDiscountPercentage: types.optional(types.string, ''),
  additionalCashback: types.optional(types.string, ''),
  bankInterestRate: types.optional(types.string, ''),
  bankInterestRatePercentage: types.optional(types.string, ''),
})

const Product = types.model('Product', {
  emiPlan: types.optional(EMIPlan, {}),
  productId: types.optional(types.string, ''),
  productAmount: types.optional(types.string, ''),
})

const Card = types.model('Card', {
  number: types.optional(types.string, ''),
  id: types.optional(types.number, 0),
  nickname: types.optional(types.string, ''),
  type: types.optional(types.string, 'CREDITCARD'),
  subType: types.optional(types.string, ''),
  ownerName: types.optional(types.string, ''),
  issuer: types.optional(types.string, ''),
  issuerLogo: types.optional(types.string, ''),
  cvv: types.optional(types.string, ''),
  expyr: types.optional(types.number, 0),
  expmon: types.optional(types.number, 0),
  expDate: types.optional(types.string, ''),
  token: types.optional(types.string, ''),
  scheme: types.optional(types.string, ''),
  isSave: types.optional(types.boolean, false),
})

const ConvenienceFee = types.model('ConvenienceFee', {
  type: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  tax: types.optional(types.string, ''),
  taxPercentage: types.optional(types.string, ''),
  // feeAddtnTaxAmount: types.optional(types.string, ''),
  // feeAddtnTaxPercent: types.optional(types.string, ''),
  // feeAmount: types.optional(types.string, ''),
  // feeCgstAmount: types.optional(types.string, ''),
  // feeCgstPercent: types.optional(types.string, ''),
  // feeIgstAmount: types.optional(types.string, ''),
  // feeIgstPercent: types.optional(types.string, ''),
  // feePercent: types.optional(types.string, ''),
  // feeSgstAmount: types.optional(types.string, ''),
  // feeSgstPercent: types.optional(types.string, ''),
  // feeTotalGstAmount: types.optional(types.string, ''),
  // feeTotalGstPercent: types.optional(types.string, ''),
  // feeType: types.optional(types.string, ''),
  // feeUgstAmount: types.optional(types.string, ''),
  // feeUgstPercent: types.optional(types.string, ''),
})

const ProcessingFee = types.model('ProcessingFee', {
  type: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  amount: types.optional(types.string, ''),
  tax: types.optional(types.string, ''),
  taxPercentage: types.optional(types.string, ''),

  // feeAddtnTaxAmount: types.optional(types.string, ''),
  // feeAddtnTaxPercent: types.optional(types.string, ''),
  // feeAmount: types.optional(types.string, ''),
  // feeCgstAmount: types.optional(types.string, ''),
  // feeCgstPercent: types.optional(types.string, ''),
  // feeIgstAmount: types.optional(types.string, ''),
  // feeIgstPercent: types.optional(types.string, ''),
  // feePercent: types.optional(types.string, ''),
  // feeSgstAmount: types.optional(types.string, ''),
  // feeSgstPercent: types.optional(types.string, ''),
  // feeTotalGstAmount: types.optional(types.string, ''),
  // feeTotalGstPercent: types.optional(types.string, ''),
  // feeType: types.optional(types.string, ''),
  // feeUgstAmount: types.optional(types.string, ''),
  // feeUgstPercent: types.optional(types.string, ''),
})

// const Metadata = types.model('Metadata', {
//   auth_amount: types.optional(types.number, 0),
//   emi_program_type: types.optional(types.number, 0),
//   tenure_id: types.optional(types.number, 0),
// })

const EMI = types.model('EMI', {
  allowZeroCost: types.optional(types.string, ''),
  bank: types.optional(types.string, ''),
  bankName: types.optional(types.string, ''),
  bankImageUrl: types.optional(types.string, ''),
  termsAndConditions: types.optional(types.string, ''),
  scheme: types.optional(types.string, ''),
  tenure: types.optional(types.string, ''),
  schemeType: types.optional(types.string, ''),
  schemeSubType: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  interestRate: types.optional(types.string, ''),
  processingMethod: types.optional(types.string, ''),
  interest: types.optional(types.string, ''),
  discount: types.optional(types.string, ''),
  cashBack: types.optional(types.string, ''),
  schemeNote: types.optional(types.string, ''),
  metadata: types.optional(types.string, ''),
  grossAmount: types.optional(types.string, ''),
  netAmount: types.optional(types.string, ''),
  totalAmount: types.optional(types.string, ''),
  processingFees: types.optional(ProcessingFee, {}),
  convenienceFees: types.optional(ConvenienceFee, {}),
  product: types.array(Product),
  card: types.optional(Card, {}),
  processingFee: types.optional(types.string, ''),
  processingFeeTax: types.optional(types.string, ''),
  convenienceFee: types.optional(types.string, ''),
  convenienceFeeTax: types.optional(types.string, ''),
  isDirectTenurePlan: types.optional(types.boolean, false),
  mobileNumber: types.optional(types.string, ''),
  paymentType: types.optional(types.string, 'EMI'),
})

export type EMIType = Instance<typeof EMI>
export { EMI }
